
// 导入模块
import * as api_user from './user'

const apiObj = {
  api_user
}
const userlogo = {
  path: '../../../static/image/userlogo.png',
  set: function (value) {
    this.path = value
  },
  getpath () {
    return this.path
  }
}
const install = function (Vue) {
  if (install.installed) return
  install.installed = true

  // 定义属性到Vue原型中
  Object.defineProperties(Vue.prototype, {
    $fetch: {
      get () {
        return apiObj
      }
    },
    $getuserlogo: {
      get () {
        return userlogo
      }
    }
  })
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/api/index.js